import React, { FC, useEffect } from 'react'
import { SingleSpaParcel } from './SingleSpaParcel'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { mfeConfigs } from '../../utilities/mfe'
import { FeatureDisabledResult } from '../FeatureDisabledResult'
import { useFeature } from '../../utilities/hooks/useFeature'
import { FeatureToggle } from '../../constants/FeatureToggles'
import { LoadingAnimation } from '../LoadingAnimation'
import Helmet from 'react-helmet'
import { useAuthToken } from '../../utilities/hooks/useAuthToken'

interface ILoyaltyPageProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const LoyaltyPage: FC<ILoyaltyPageProps> = inject('currentCompanyStore')(
  ({ currentCompanyStore }) => {
    const canUseLoyaltyService = useFeature(
      FeatureToggle.CAN_USE_LOYALTY_SERVICE,
      currentCompanyStore,
    )
    const authToken = useAuthToken()

    useEffect(() => {
      return () => {
        currentCompanyStore!.getExternalLoyaltyProvider(currentCompanyStore!.company!.id)
      }
    }, [])

    const merchantId = `blc-${currentCompanyStore?.company?.id}`
    const platform = 'pos'
    const basename = `/company/${currentCompanyStore?.company?.id}/dashboard/settings/loyalty`

    if (canUseLoyaltyService === null) return <LoadingAnimation />

    return (
      <>
        <Helmet>
          <title>Settings | Loyalty</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        {canUseLoyaltyService ? (
          <SingleSpaParcel
            basename={basename}
            authToken={authToken}
            merchantId={merchantId}
            platform={platform}
            config={mfeConfigs.LOAD_LOYALTY_PAGE}
          />
        ) : (
          <FeatureDisabledResult />
        )}
      </>
    )
  },
)
